module.exports = __webpack_public_path__ + "img/2200f.670942f7.png";